// Load base styles first
import "./src/styles/global.css";

// Load subsite styles if specified
if (process.env.GATSBY_SUBSITE && process.env.GATSBY_SUBSITE === "yoga") {
  require(`./src/styles/subsites/${process.env.GATSBY_SUBSITE}.css`);
}

export const onClientEntry = () => {
  if (
    process.env.GATSBY_SUBSITE === "yoga" &&
    typeof document !== "undefined"
  ) {
    document.body.classList.add("yoga");
  }
};

// Load Prism syntax highlighting styles
require("prismjs/plugins/line-numbers/prism-line-numbers.css");
require("prismjs/themes/prism-tomorrow.css");
